export abstract class CacheService {
  abstract getItem(key:string) : string[]
  abstract setItem(key:string, value:string[]) : void
}

